import styled from 'styled-components';

export default styled.div`
  position: relative;
  width: 100%;
  padding-top: 75%;
  overflow: hidden;
  margin-bottom: 5px;
`;
